import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, createSlots as _createSlots } from "vue"

const _hoisted_1 = { key: 2 }

import RestTableItem from './components/VATableItem.vue';

import propsOptions from './extends/props';
import {
  useRequestPagination,
  formatRecordValue,
  useSelection,
} from './extends/hooks';
import { useRoute, useRouter } from 'vue-router';


export default /*@__PURE__*/_defineComponent({
  __name: 'VATable',
  props: propsOptions,
  setup(__props, { expose: __expose }) {

const props = __props;
const route = useRoute();
const router = useRouter();

const to = () => {
  router.push({
    path: route.path,
    query: {
      ...route.query,
      page: pagination.value.current,
      size: pagination.value.pageSize,
    },
  });
};

const page = Number(route.query.page || 1);
const size = Number(route.query.size || 20);

// 横向滚动条，如果expand开启，则取消滚动条，不然会超宽
const xScroll = () =>{
  return props.expand?null:{ x: 'max-content' }
}

const {
  loading,
  pagination,
  data: dataSource,
  handleTableChange,
  reload,
} = useRequestPagination(
  props.uri || '',
  props.defaultParams,
  page,
  size,
  to,
  props.manual,
    props.format
);

const { data: selectedRowKeys, change: onSelectChange } = useSelection();

__expose({ reload, selectedRowKeys, dataSource });

return (_ctx: any,_cache: any) => {
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_table = _resolveComponent("a-table")!

  return (_openBlock(), _createBlock(_component_a_table, {
    class: "ant-table-striped",
    scroll: xScroll(),
    "row-selection": 
      props.selection
        ? { selectedRowKeys: _unref(selectedRowKeys), onChange: _unref(onSelectChange) }
        : null
    ,
    "row-class-name": 
      (_record, index) => (index % 2 === 1 ? 'table-striped' : null)
    ,
    "row-key": props.rowKey,
    columns: props.columns,
    "data-source": _unref(dataSource),
    bordered: props.bordered,
    loading: _unref(loading),
    pagination: props.pagination && _unref(pagination),
    onChange: _unref(handleTableChange),
    size: "small"
  }, _createSlots({
    bodyCell: _withCtx(({ column, record }) => [
      (column.slot)
        ? _renderSlot(_ctx.$slots, column.slot, {
            key: 0,
            dataIndex: column.dataIndex,
            record: record,
            dataSource: _unref(dataSource)
          })
        : (column.ellipsis === true)
          ? (_openBlock(), _createBlock(_component_a_tooltip, { key: 1 }, {
              title: _withCtx(() => [
                _createElementVNode("div", null, _toDisplayString(_unref(formatRecordValue)(record, column)), 1)
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", {
                  style: _normalizeStyle({ width: column.width + 'px', whiteSpace: 'nowrap', overflow:'hidden', textOverflow: 'ellipsis' })
                }, [
                  _createVNode(RestTableItem, {
                    record: record,
                    column: column
                  }, null, 8, ["record", "column"])
                ], 4)
              ]),
              _: 2
            }, 1024))
          : (_openBlock(), _createElementBlock("span", _hoisted_1, [
              _createVNode(RestTableItem, {
                record: record,
                column: column
              }, null, 8, ["record", "column"])
            ]))
    ]),
    _: 2
  }, [
    (props.expand === true)
      ? {
          name: "expandedRowRender",
          fn: _withCtx(({ record }) => [
            _renderSlot(_ctx.$slots, "expandedRowRender", { record: record })
          ]),
          key: "0"
        }
      : undefined,
    (props.expand === true)
      ? {
          name: "expandColumnTitle",
          fn: _withCtx(({ record }) => [
            _renderSlot(_ctx.$slots, "expandColumnTitle", { record: record })
          ]),
          key: "1"
        }
      : undefined
  ]), 1032, ["scroll", "row-selection", "row-class-name", "row-key", "columns", "data-source", "bordered", "loading", "pagination", "onChange"]))
}
}

})